import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, AfterViewInit, TemplateRef, ViewChild } from '@angular/core';
import { EFormControl } from '../../e-form-control.model';
import { EFormService } from '../../e-form.service';
import { Subscription } from 'rxjs';
import { EFormAttachment } from '../../e-form-attachment.model';
import { System } from '../../../System';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import * as moment from 'moment';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { StudentAttachment } from '../../../../shared-modules/student-attachment/student-attachment.model';
import { CustomDataTemplateRef } from '../../../../shared-modules/customization-framework/models/custom-data-template-ref.model';
import { ErrorList } from '../../../controls/error-prompt/error-list.model';
import { CustomDataFieldComponent } from '../../../../shared-modules/customization-framework/custom-data-field/custom-data-field.component';
import { EFormConfiguration } from '../../e-form-config.model';
import { TylTranslatePipe } from '../../../pipes/tyl-translate.pipe';
import { YearService } from '../../../year/year.service';


@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'e-form-viewer-control',
  templateUrl: './e-form-viewer-control.component.html',
  styleUrls: ['./e-form-viewer-control.component.css']// ,
  // encapsulation: ViewEncapsulation.None
})
export class EFormViewerControlComponent implements OnInit, OnDestroy, AfterViewInit {

  private _control: EFormControl;
  public get control(): EFormControl {
  return this._control;
  }
  @Input() public set control(value: EFormControl) {
    this._control = value;
    this.originalEditableValue = this._control.Editable == null || this._control.Editable == true;
  }
  
  private _editable = false;
  public get editable(): boolean {
  return this._editable;
  }
  @Input() public set editable(value: boolean) {
    this._editable = value;
    if (this.control) {
      if (value == false) {
        this.control.Editable = false;
      }
      else {
        this.control.Editable = this.originalEditableValue;
      }
    }
  }
  @Input() disableMergeFields: boolean;
  @Input() print: boolean;
  @Input() showConditionals: boolean;
  @Input() masterId: number;
  @Input() designPageIndex: number;
  @Input() config: EFormConfiguration;
  @Output() viewInitialized: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() controlValueChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('customField') customField: CustomDataFieldComponent;
  showConditionalObjects = false;
  radioValues: string[] = [];
  radioLabels: string[] = [];
  radioIds: string[] = [];
  viewType: string;
  subscriptions: Subscription[] = [];
  mergeFieldDependantControlIds: number[] = [];
  dateValue: moment.Moment;
  highlightChanges = false;
  pipeTrigger = false;
  maxFileSizeByte = 0;
  maxFileSizeMessage = '';
  contentTemplate: TemplateRef<any>;
  originalEditableValue = true;
  // eFormAttachment: EFormAttachment[] = []
  constructor(private eFormService: EFormService,
    private loginService: LoginService,
    private translateService: TranslateService,
    private tylTranslatePipe: TylTranslatePipe,
    private yearService: YearService) {
      const x = this.masterId;
  }

  ngOnInit() {
    if (this.control) {
      //  ONE-10856 Mobile is saving the checkbox value as a string
      if (this.control.ControlType == 'checkbox') {
        if (this.control.Value == 'true') { this.control.Value = true; }
        if (this.control.Value == 'false') { this.control.Value = false; }
      }
      if (this.editable == false) {
        this.control.Editable = false;
      }
      else {
        this.control.Editable = this.originalEditableValue;
      }
      if (this.control.Width) {
        if (!this.control.Width.toString().includes('px') && !this.control.Width.toString().includes('%')) {
          this.control.Width = this.control.Width.toString() + 'px';
        }
      }
    }
    this.eFormService.eFormAttachment.forEach(att => {
      if (this.control.AttachmentId == att.ID) {
        this.control.Attachment = att;
      }
    });
    // // #########
    // if(this.control.ControlType == 'attachment' && this.control.Attachment){
    //   this.eFormService.eFormAttachment.push(this.control.Attachment);
    // }
    // // #########
    this.viewType = this.eFormService.viewType;
    if (this.config.NewForm && this.control.DropdownOptions && this.control.DropdownOptions.length > 0) {
      this.setDefaultOptionFlags();
    }
    this.setInitialVisibility();
    this.subscriptions.push(this.eFormService.observableControlValueChangedStream$.subscribe(parentControl => {
      if (this.control.ParentObjectId == parentControl.Id) {
        this.control.Visible = this.eFormService.isConditionMet(this.control.Condition, parentControl);
        if (!this.control.Visible && this.control.ControlType != 'text') {
          this.control.Value = null;
          this.dateValue = null;
          if (this.control.ControlType == this.eFormService.controlTypes.attachment) {
            this.control.Attachment = null;
            this.control.AttachmentId = null;
            this.control.PreviousAttachmentId = null;
          }
          this.valueChanged();
        }
        else if (this.control.Visible && this.control.ControlType != 'text' && this.control.DropdownOptions && this.control.DropdownOptions.length > 0) {
          this.control.DropdownOptions.forEach( option => {
            if (option.Default) {
              if (this.control.LinkedDBField != -1) {
                this.control.Value = option.Code;
              }
              else {
                this.control.Value = option.CodeDescription;
              }
            }
          });
        }
      }
      if (this.mergeFieldDependantControlIds.includes(parentControl.Id)) {
        this.transformMergeTags();
        this.pipeTrigger = !this.pipeTrigger;
        setTimeout(() => {
          this.pipeTrigger = !this.pipeTrigger;
        }, 100);
      }
    }));
    this.subscriptions.push(this.eFormService.observableShowConditionalObjectsStream$.subscribe(showConditional => {
      this.showConditionalObjects = showConditional;
    }));
    this.subscriptions.push(this.eFormService.observableMergeFieldValuesRetrievedStream$.subscribe(fieldsExist => {
      this.transformMergeTags();
      this.pipeTrigger = !this.pipeTrigger;
      setTimeout(() => {
        this.pipeTrigger = !this.pipeTrigger;
      }, 100);
    }));
    this.subscriptions.push(this.eFormService.observablePipeTriggerStream$.subscribe(trigger => {
      this.transformMergeTags();
      this.pipeTrigger = !this.pipeTrigger;
      setTimeout(() => {
        this.pipeTrigger = !this.pipeTrigger;
      }, 100);
    }));
    if (this.control.ControlType == this.eFormService.controlTypes.radioButtons) {
      this.setUpRadioButtons();
    }
    else if (this.control.ControlType == this.eFormService.controlTypes.image || this.control.ControlType == this.eFormService.controlTypes.linkToFile || this.control.ControlType == this.eFormService.controlTypes.attachment) {
      this.getAttachment();
    }
    else if (this.control.ControlType == this.eFormService.controlTypes.date) {
      if (this.control.Value) {
        this.dateValue = moment(this.control.Value);
        if (!this.dateValue.isValid()) {
          this.dateValue = null;
        }
      }
    }
    this.getMergeFieldDependantControls();
    if (this.eFormService.changes && this.eFormService.changes.find(o => o.ObjectType == 'Control' && o.FieldId == this.control.Id) != null) {
      this.highlightChanges = true;
    }
    if (this.control.ControlType == 'attachment') {
      this.setMaxFileSize();
    }
    if (this.control.ControlType == 'component') {
      if (this.eFormService.contentTemplates && this.eFormService.contentTemplates.length > 0) {
        const customDataTemplateRef: CustomDataTemplateRef = this.eFormService.contentTemplates.find(ct => ct.RefName == this.control.CustomFieldRefName);
        if (customDataTemplateRef) {
          this.contentTemplate = customDataTemplateRef.TemplateRef;
        }
      }
    }
    this.subscriptions.push(this.eFormService.observableReadOnlyStatusChangedStream$.subscribe(control => {
      if (control == this.control) {
        this.editable = control.Editable;
      }
    }));

    this.control.validateFunction = this.validate.bind(this);
    this.control.DesignPageIndex = this.designPageIndex;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loaded();
    }, 0);
  }

  getMergeFieldDependantControls() {
    this.mergeFieldDependantControlIds = [];
    if (this.control.ControlType == this.eFormService.controlTypes.text) {
      this.mergeFieldDependantControlIds = this.mergeFieldDependantControlIds.concat(this.extractMergeTagIds(this.control.Value));
    }
    else {
      this.mergeFieldDependantControlIds = this.mergeFieldDependantControlIds.concat(this.extractMergeTagIds(this.control.Label));
      if (this.control && this.control.DropdownOptions) {
        this.control.DropdownOptions.forEach(opt => {
          this.mergeFieldDependantControlIds = this.mergeFieldDependantControlIds.concat(this.extractMergeTagIds(opt.CodeDescription));
        });
      }
    }
  }

  transformMergeTags() {
    // Moved to MergeFieldPipe to prevent overriding values in formData

    // when merge tag values are pulled from the database, we can just replace the tag rather than using a pipe.  That way saved forms are exactly what the parent saw
    // when they saved the form even if the database values changed since then.
    // when the value is obtained from another object on the form, we need to use the pipe so that it can keep updating as the parent object changes.
    // if (!this.disableMergeFields) {
    //   if (this.control.ControlType == this.eFormService.controlTypes.text) {
    //     //this.control.Value = this.tylTranslatePipe.transform(this.control.Value);
    //     this.control.Value = this.eFormService.transformDatabaseMergeTag(this.control.Value);
    //   }
    //   else {
    //     //this.control.Label = this.tylTranslatePipe.transform(this.control.Label);
    //     this.control.Label = this.eFormService.transformDatabaseMergeTag(this.control.Label);
    //     this.control.DropdownOptions.forEach(opt => {
    //       opt.CodeDescription = this.eFormService.transformDatabaseMergeTag(opt.CodeDescription);
    //     });
    //   }
    // }
  }

  extractMergeTagIds(text: string): number[] {
    const ids: number[] = [];
    let otherMatches: string[] = [];
    const otherFieldsRegEx = new RegExp('<<(.*?)>>', 'g');
    const otherFieldsSanitizedRegEx = new RegExp('&lt;&lt;(.*?)&gt;&gt;', 'g');
    otherMatches = text.match(otherFieldsRegEx);
    if (!otherMatches) {
      otherMatches = text.match(otherFieldsSanitizedRegEx);
    }

    if (otherMatches) {
      otherMatches.forEach(mergeTag => {
        const id = this.eFormService.getControlIdFromMergeTag(mergeTag);
        if (!isNaN(id)) {
          ids.push(id);
        }
      });
    }
    return ids;
  }

  ngOnDestroy() { }

  setInitialVisibility() {
    this.control.Visible = true;

    if (this.control.ParentObjectId > 0) {
      const parentObject = this.eFormService.allFormControls.find(o => o.Id == this.control.ParentObjectId);
      if (parentObject) {
        this.control.Visible = this.eFormService.isConditionMet(this.control.Condition, parentObject);

        if (!this.control.Visible) {
          if (this.eFormService.inputControlTypes.includes(this.control.ControlType)) {
            this.control.Value = null;
            this.control.Attachment = null;
            this.control.AttachmentId = null;
            this.control.PreviousAttachmentId = null;
          }
        }
        else if (this.control.Value == null && this.control.DropdownOptions && this.control.DropdownOptions.length > 0) {
          this.control.DropdownOptions.forEach( option => {
            if (option.Default) {
              if (this.control.LinkedDBField != -1) {
                this.control.Value = option.Code;
              }
              else {
                this.control.Value = option.CodeDescription;
              }
            }
          });
        }
      }
    }
  }

  setDefaultOptionFlags() {
    if (this.control.DropdownOptions.filter( option => option.Default).length == 0) {
      this.control.DropdownOptions.forEach( option => {
        if (this.control.LinkedDBField != -1) {
          option.Default = this.control.Value == option.Code;
        }
        else {
          option.Default = this.control.Value == option.CodeDescription;
        }
      });
    }
  }

  getAttachment() {
    if (this.control.AttachmentId && ((this.control.Attachment == null || this.control.Attachment == undefined) || (this.control.Attachment != null && this.control.Attachment != undefined && !this.control.Attachment.FileDataBase64))) {
      this.control.Attachment = new EFormAttachment();
      this.control.PreviousAttachmentId = null;
      this.subscriptions.push(this.eFormService.getEFormAttachment(this.control.AttachmentId).subscribe(attachment => {
        if (attachment) {
          this.control.Attachment = attachment;
          this.control.PreviousAttachmentId = this.control.AttachmentId;
          this.eFormService.eFormAttachment.push(attachment);
        }
        else {
          this.control.Attachment = new EFormAttachment();
        }
      }));
    }
    else if (!this.control.Attachment) {
      this.control.Attachment = new EFormAttachment();
    }
  }

  valueChanged() {
    if (this.control.ControlType == this.eFormService.controlTypes.date && !this.control.CustomField) {
      this.dateValue = moment(this.dateValue);
      if (this.dateValue.isValid()) {
        this.control.Value = this.dateValue.format('YYYY-MM-DD');
      }
      else {
        this.control.Value = '';
      }
    }
    this.eFormService.controlValueChanged(this.control);
  }

  setUpRadioButtons() {
    if (this.control.DropdownOptions) {
      if (this.control.Value) {
        this.control.Value = this.control.Value.trim();
      }
      this.control.DropdownOptions.forEach(opt => {
        opt.Code = opt.Code.trim();
        this.radioValues.push(opt.Code.trim());
        this.subscriptions.push(this.translateService.get(opt.CodeDescription).subscribe((res: string) => {
          this.radioLabels.push(res.trim());
        }));
        const id = 'rb' + (opt.Code.trim()).replace(' ', '_');
        this.radioIds.push(id + '_' + this.control.Label);
      });
    }
  }

  SetRadioValue(obj, code) {
    this.control.Value = code;
    this.valueChanged();
  }


  saveAttachment(attachment: EFormAttachment) {
    if (this.loginService.LoginSettings.V10) {
      System.viewFileFromBase(attachment.FileDataBase64, attachment.FileType, attachment.OriginalFileName);
    }
    else {
      const studentAttachment: StudentAttachment = {
        DocumentId: attachment.ID,
        DocumentName: '',
        DocumentBase64: '',
        DocumentMimeType: '',
        DocumentModuleName: 'Documents',
        ReportParameters: [],
        ReportType: 0
      };
      window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
      const win = window.open(System.baseUrl + 'studentattachment', '_blank');
    }
  }

  attachmentChanged() {
    this.control.AttachmentId = null;
  }

  linkClick() {
    let mimeType = this.control.Attachment.FileType;
    if (this.control.Attachment.FileExtension.toLowerCase() == '.txt' || this.control.Attachment.FileExtension.toLowerCase() == '.rtf') {
      mimeType = 'text/plain';
    }
    else if (this.control.Attachment.FileExtension.toLowerCase() == '.doc' || this.control.Attachment.FileExtension.toLowerCase() == '.docx') {
      mimeType = 'application/msword';
    }
    else if (this.control.Attachment.FileType.toLowerCase() == 'applicatio') {
      mimeType = 'application/' + this.control.Attachment.FileExtension.substr(1);
    }
    System.viewFileFromBase(this.control.Attachment.FileDataBase64, mimeType, this.control.Label);
  }

  loaded() {
    requestAnimationFrame(() => { this.startRender(); });
  }

  startRender() {

    requestAnimationFrame(() => { this.rendered(); });
  }

  rendered() {
    setTimeout(() => {
      this.viewInitialized.emit(true);
    }, 0);
  }

  setMaxFileSize() {
    this.maxFileSizeByte = this.eFormService.maxFileSizeKB * 1048;

    if (this.eFormService.maxFileSizeKB > 1000 && this.eFormService.maxFileSizeKB % 1000 == 0) {
      this.maxFileSizeMessage = ' The maximum file size is ' + this.eFormService.maxFileSizeKB / 1000 + ' MB.';
    }
    else {
      this.maxFileSizeMessage = ' The maximum file size is ' + this.eFormService.maxFileSizeKB + ' kB.';
    }
  }

  validate(): ErrorList[] {
    let errors: ErrorList[] = [];

    if (this.control.CustomField && this.customField) {
      errors = this.customField.validate();
    }

    return errors;
  }
}
